module.exports = __webpack_public_path__ + "img/fastcharger-suggestion.9b28cf9a.png";